import Share from "components/Share"

export default function Social() {
  return <Share />
}
